import { useState } from "react";
import { Img, DemoAction } from "./shared";

const FOCUS = [
  { t: "Führung", q: "Wie führe ich, ohne mich selbst zu verlieren?", d: "Für neue und erfahrene Führungskräfte, die Klarheit in Rolle und Kommunikation suchen." },
  { t: "Neuorientierung", q: "Was kommt als Nächstes?", d: "Begleitung bei beruflichen Wendepunkten – strukturiert und ehrlich." },
  { t: "Teams", q: "Wie arbeiten wir wirklich gut zusammen?", d: "Workshops für Teams, die Reibung in Energie verwandeln möchten." },
];

export default function Coaching({ wide, onCta }) {
  const [f, setF] = useState(0);
  const cur = FOCUS[f];
  return (
    <div className="bg-[#FBF7F2] text-[#2D2A26]" style={{ fontFamily: "'DM Sans Variable', sans-serif" }}>
      <header className="flex items-center justify-between px-5 pt-12 pb-4" style={wide ? { paddingTop: 24, paddingLeft: 56, paddingRight: 56 } : undefined}>
        <span className="text-[20px]" style={{ fontFamily: "'DM Serif Display', serif" }}>Klara Weiss</span>
        <span className="text-[12px] text-[#7A6F63]">Coaching & Beratung</span>
      </header>
      <section className={wide ? "grid grid-cols-[1.3fr_1fr] gap-12 px-14 py-14" : "px-5 py-6"}>
        <h1 className={`leading-[1.02] ${wide ? "text-[76px]" : "text-[46px]"}`} style={{ fontFamily: "'DM Serif Display', serif" }}>
          Gute Fragen<br />verändern <em className="text-[#C2562D]">mehr</em><br />als schnelle<br />Antworten.
        </h1>
        <div className={wide ? "flex flex-col justify-end" : "mt-6"}>
          <div className="h-[220px] overflow-hidden rounded-sm"><Img k="desk1" alt="Arbeitsplatz" /></div>
          <p className="mt-4 text-[14px] leading-relaxed text-[#5C544B]">Persönliche Begleitung für Menschen und Unternehmen in Veränderung. Eine fiktive Designstudie.</p>
        </div>
      </section>
      <section className={wide ? "px-14 pb-16" : "px-5 pb-12"}>
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#C2562D]">Schwerpunkt wählen</p>
        <div className="mt-3 grid grid-cols-3 border-y border-[#2D2A26]">
          {FOCUS.map((x, i) => (
            <button key={x.t} type="button" data-noswipe aria-pressed={f === i} onClick={() => setF(i)}
              className={`py-3 text-[13px] font-medium transition-colors ${i ? "border-l border-[#2D2A26]" : ""} ${f === i ? "bg-[#2D2A26] text-[#FBF7F2]" : ""}`}>{x.t}</button>
          ))}
        </div>
        <blockquote className={`mt-6 leading-tight ${wide ? "text-[40px]" : "text-[28px]"}`} style={{ fontFamily: "'DM Serif Display', serif" }}>„{cur.q}“</blockquote>
        <p className="mt-3 max-w-[520px] text-[14px] leading-relaxed text-[#5C544B]">{cur.d}</p>
        <DemoAction label="Kennenlerngespräch anfragen →" onCta={onCta} className="mt-6 text-[15px] font-semibold text-[#C2562D]" />
      </section>
    </div>
  );
}
